import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

const aiActions = defineAIActions({
  namespace: 'analytics',
  actions: [
    {
      id: 'generate-report',
      name: '生成报告',
      description: '自动生成数据分析报告',
      parameters: [
        { name: 'type', type: 'string', description: '报告类型', required: true },
        { name: 'period', type: 'string', description: '时间范围', required: false },
      ],
      handler: async (params) => {
        return {
          type: 'report',
          data: { type: params.type, status: 'generating' },
          message: '报告正在生成中...',
        };
      },
    },
    {
      id: 'analyze-trends',
      name: '趋势分析',
      description: '分析数据趋势和异常点',
      parameters: [],
      handler: async () => {
        return {
          type: 'report',
          data: {
            trend: 'up',
            insights: ['粉丝增长率高于平均', '互动率有所下降', '发布频率建议增加'],
          },
          message: '趋势分析完成',
        };
      },
    },
    {
      id: 'insights',
      name: '智能洞察',
      description: '发现数据中的关键洞察',
      parameters: [],
      handler: async () => {
        return {
          type: 'table',
          data: [
            { insight: '周三发布效果最好', impact: '高' },
            { insight: '护肤类内容互动率最高', impact: '中' },
            { insight: '视频内容收藏率高于图文', impact: '高' },
          ],
          message: '发现3个关键洞察',
        };
      },
    },
  ],
});

export default definePlugin({
  meta: {
    name: 'analytics',
    version: '1.0.0',
    displayName: '数据分析',
    description: '矩阵数据分析、报表生成、趋势洞察',
    icon: 'bar-chart',
    category: 'analytics',
  },

  onLoad: async () => {
    console.log('[Plugin] Analytics loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Analytics unloaded');
  },

  routes: [
    {
      path: '/analytics',
      lazy: async () => {
        const { AnalyticsDashboard } = await import('./pages/AnalyticsDashboard');
        return { Component: AnalyticsDashboard };
      },
    },
    {
      path: '/analytics/accounts',
      lazy: async () => {
        const { AccountAnalytics } = await import('./pages/AccountAnalytics');
        return { Component: AccountAnalytics };
      },
    },
    {
      path: '/analytics/content',
      lazy: async () => {
        const { ContentAnalytics } = await import('./pages/ContentAnalytics');
        return { Component: ContentAnalytics };
      },
    },
    {
      path: '/analytics/reports',
      lazy: async () => {
        const { ReportCenter } = await import('./pages/ReportCenter');
        return { Component: ReportCenter };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'analytics',
      title: '数据分析',
      icon: 'bar-chart',
      path: '/analytics',
      order: 6,
    },
  ],

  aiActions,
});

